import React from 'react';
import classNames from 'classnames';
import {Button as SemanticButton, Image} from 'semantic-ui-react';

import {Props} from './types';

import './index.scss';

const Button = (props: Props) => {
  return (
    <div
      className={classNames('b__common-button', [
        props.className,
        {'read-only': props.readOnly},
        {disabled: props.disabled},
      ])}
    >
      <SemanticButton
        className={classNames({
          rounded: props.rounded,
          yellow: props.color === 'yellow',
          red: props.color === 'red',
          green: props.color === 'green',
          large: props.large,
          default: !props.color,
        })}
        onClick={() => {
          if (props.onClick) {
            props.onClick();
          }
          if (props.onSubmit) {
            props.onSubmit();
          }
        }}
        loading={props.loading}
        disabled={props.disabled}
        fluid={props.notFluid ? false : true}
        type={props.type ? props.type : 'button'}
        style={props.style ? props.style : null}
      >
        {props.src ? (
          <Image src={props.src} className="b__button-icon" />
        ) : null}
        {props.text || props.children}
      </SemanticButton>
    </div>
  );
};

export default Button;
